import * as React from "react";
import { TopTenHoldingModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/PortfolioDetails/TopTenHoldingModel";
import { LongLabelsBarChart } from "../../../../../../../Shared/Chart/LongLabelsBarChart";
import { AriaTooltip } from "../../../../../../../Shared/Tooltip/AriaTooltip";

interface ITopTenChart {
    data: Array<TopTenHoldingModel>;
}
export const TopTenChart = (props: ITopTenChart) => {
    return (
        <>
            <div className="flex-space pb-8 pt-30">
                <h2 className="h3 mb-0">Top 10</h2>
            </div>
            <div className="panel pt-30 pr-60 pb-30 pl-30">
                <div className="mb-23 text-size-14">
                    Breakdown by Top 10 Holdings
                    <AriaTooltip
                        cssWrapper="is-info-icon ml-8"
                        showCloseButton={true}
                        title="More on breakdown by top 10 holdings"
                    >
                        Top 10 Results table will show Model Portfolio instruments as standalone funds. These funds will
                        be aggregated where held across multiple wrappers. Furthermore, GBP Cash will not show in this
                        table.
                    </AriaTooltip>
                </div>

                <LongLabelsBarChart
                    data={props.data.map((ele) => {
                        return { value: ele.Allocation, name: ele.DisplayName };
                    })}
                    height={380}
                    itemLabel="Instrument name"
                    valueLabel="Percentage value"
                    cellCss="cell-38"
                />
            </div>
        </>
    );
};
